import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_NEW_PASSWORD_ROUTE } from '../shared/constants/routes';
import { AuthNewPasswordComponent } from './auth-new-password/auth-new-password.component';
import { PendingCognitoGuard } from '../guards/pending-cognito.guard';

const routes: Routes = [
  {
    path: AUTH_NEW_PASSWORD_ROUTE,
    component: AuthNewPasswordComponent,
    canActivate: [PendingCognitoGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthNewPasswordRoutingModule {}
